export default {
  productVatIncludedInfo: {
    id: 'product_vat_included_info',
    defaultMessage: '',
  },
  productVatFaqLink: {
    id: 'product_vat_faq_link',
    defaultMessage: '',
  },
  productVatFaq: {
    // reused in ServiceFeeModal.translations.ts
    id: 'product_vat_faq',
    defaultMessage: 'Learn more',
  },
}
